export const PaymentGatewayTypes = {
  CSOB: 'CSOB',
  GP: 'GP',
};
